export default function uploadImages()  {
    // tinymce.PluginManager.add('uploadImages', function(editor, url) {
//
//     editor.ui.registry.addButton('uploadImagesButton', {
//         text: '',
//         icon : 'image',
//         onAction: function() {
//             editor.execCommand('mceImage');
//             setTimeout(()=>{
//                 document.getElementsByClassName('tox-dialog__body-nav-item')[2].click()
//             })
//         }
//     });
//
//     return {
//         getMetadata: function () {
//             return  {
//                 name: "uploadImages",
//                 url: "http://www.1dq.com",
//             };
//         }
//     };
// });

    tinymce.PluginManager.add('uploadImages', function (editor, url) {
        function openFileUpload(e) {
            let input = document.createElement("input");
            input.type = "file";
            input.accept = "image/jpeg,image/png";
            input.click();

            //添加事件
            input.addEventListener("change", function (e) {
                let files = e.target.files;
                let file = files.length > 1 ? files[0] : files[0]
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function() {
                    console.log(reader.result)
                    //向富文本插入内容
                    editor.insertContent(`<img src="${reader.result}" class="editor-image"  >`)
                    //移除标签
                    input.remove();
                };
            })
        }

        // 注册一个工具栏按钮名称
        editor.ui.registry.addButton('uploadImagesButton', {
            icon: 'image',
            tooltip: '图片上传',
            onAction: function (...e) {
                openFileUpload(e);
            }
        });
        return {
            getMetadata: function () {
                return  {
                    name: "uploadImages",
                    url: "http://www.1dq.com",
                };
            }
        };
    });

}